import React from 'react'
import PropTypes from 'prop-types'
import { useAuthorization } from '../../containers/AuthorizationProvider/AuthorizationProvider.hooks'

/**
 * The Public Section's component.
 */
const PublicSection = props => {
  const { children, fallback, rule } = props
  const { isPrivated } = useAuthorization()
  const result = rule(isPrivated)

  if (!result) {
    return fallback(isPrivated)
  }

  return <>{children}</>
}

PublicSection.defaultProps = {
  fallback: () => null,
  redirectTo: '',
  rule: isPrivated => !isPrivated
}
PublicSection.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  rule: PropTypes.func
}

export default PublicSection
